import styled from '@emotion/styled';

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.neutral[100]};
  position: relative;
`;

export const LoginBox = styled.div`
  background: ${({ theme }) => theme.colors.neutral[0]};
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.05);
  max-width: 496px;
  padding: 48px 48px 32px;
  width: 496px;
  position: relative;
`;

export const LoginBoxSignboard = styled.div`
  position: absolute;
  gap: 10px;
  top: -62px;
  left: 0px;
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  overflow: hidden;
`;
